import React, { useState } from 'react';
import { ControllerIcon, GamingWheelIcon, KeyboardIcon, RemoteController, SteeringLayout, KeyboardLayout } from "@util/svgicon";

const Control = () => {

  const [controlActiveTab, setIsControlActiveTab] = useState(1)

  const handleTabClick = (tabNumber) => {
    setIsControlActiveTab(tabNumber)
  }

  return (
    <div className="Control_panel">
      <div className="control_diff_way">
        <button className="btn_controller" onClick={() => handleTabClick(1)} style={controlActiveTab === 1 ? { backgroundColor: '#737373' } : { color: '#000000' }}>
          <ControllerIcon />
          <p className="contoller_letter">Controller</p>
        </button>
        <button className="btn_controller" onClick={() => handleTabClick(2)} style={controlActiveTab === 2 ? { backgroundColor: '#737373' } : { color: '#000000' }}>
          <GamingWheelIcon />
          <p className="contoller_letter">Gaming Wheel</p>
        </button>
        <button className="btn_controller" onClick={() => handleTabClick(3)} style={controlActiveTab === 3 ? { backgroundColor: '#737373' } : { color: '#000000' }}>
          <KeyboardIcon />
          <p className="contoller_letter">Keyboard</p>
        </button>
      </div>
      {controlActiveTab === 1 &&
        <div style={{ width: '50%' }}>
          <RemoteController />
        </div>
      }
      {controlActiveTab === 2 &&
        <div style={{ width: '75%' }}>
          <SteeringLayout />
        </div>
      }
      {controlActiveTab === 3 &&
        <div style={{ width: '50%' }}>
          <KeyboardLayout />
        </div>
      }
    </div>
  )
}

export default Control;